import { render, staticRenderFns } from "./MantenedorTramosPantalla.vue?vue&type=template&id=410e94fa&"
import script from "./MantenedorTramosPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTramosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports